import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { CidadeInput, CidadeOutput } from 'src/app/@shared/models/cidade.model';
import { exportarExcelAbrangenciaRequest } from 'src/app/@shared/models/abrangencia.model';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

//Chamada do filtro;
const filtro = (obj: exportarExcelAbrangenciaRequest) => { // Alterar o Model do Request;
  const filtro = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filtro);
  };

@Injectable({
  providedIn: 'root'
})
export class ManutencaoAbrangenciaService {

  constructor(private http: HttpClient) { }

  selecionarClasses(): Observable<any> {
    return this.http.get('Abrangencia/SelecionarClasses', httpOptions) as Observable<any>;
  }

  selecionarOpcoes(): Observable<any> {
    return this.http.get('Abrangencia/SelecionarOpcao', httpOptions) as Observable<any>;
  }

  selecionarUf(): Observable<any> {
    return this.http.get('Abrangencia/SelecionarUf', httpOptions) as Observable<any>;
  }

  selecionarCidade(req: CidadeInput): Observable<HttpResponse<CidadeOutput[]>> {
    return this.http
      .get<CidadeOutput[]>(
        `Abrangencia/SelecionarCidade?${req.nome ? `&nome=${req.nome}` : ''}` +
        `${req.uf ? `&ufId=${req.uf}` : ''}` +
        `${req.paginaAtual ? `&paginaAtual=${req.paginaAtual}` : ''}` +
        `${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  selecionarLocal(id: number): Observable<any> {
    return this.http.get(`Abrangencia/SelecionarLocal`, httpOptions) as Observable<any>;
  }

  selecionarCepInicialEFinal(id: number): Observable<any> {
    return this.http.get(`Abrangencia/SelecionarCepInicialEFinal?cidadeId=${id}`, httpOptions) as Observable<any>;
  }

  selecionarAbrangencia(obj: any): Observable<any> {
    return this.http.post(`Abrangencia/SelecionarAbrangencia`, obj, httpOptions) as Observable<any>;
  }

  selecionarTipoUpload(): Observable<any> {
    return this.http.get(`Abrangencia/SelecionarTipoUpload?cidadeId`, httpOptions) as Observable<any>;
  }

  selecionarInconsistencias(obj: any): Observable<any> {
    return this.http.post(`Abrangencia/selecionarInconsistencias`, obj, httpOptions) as Observable<any>;
  }

  uploadExcel(obj: any): Observable<any> {
    return this.http.put('Abrangencia/UploadExcel', obj, httpOptions) as Observable<any>;
  }

  //Chamada do Endpoints Excel;
  public exportarExcel(obj: exportarExcelAbrangenciaRequest): Observable<any> {
    return this.http.get<any>(`Abrangencia/Excel?${filtro(obj)}`, httpOptions);
  }

  public exportarCidades(ufId: number): Observable<any> {
    return this.http.get<any>(`Abrangencia/DownloadCidades?ufId=${ufId}`, httpOptions);
  }

  public downloadTemplate(opcaoId: number): Observable<any> {
    return this.http.get<any>(`Abrangencia/DownloadTemplate/${opcaoId}`, httpOptions);
  }

  public getReceitasById(): Observable<any> {
    return this.http.get<any>(`Receita/consultaByTipoServico/1`, httpOptions)
  };

}
